import {Component, Inject, Input, OnInit, Output} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';

@Component({
    selector: 'app-popup-message',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.css'],
    standalone: false
})
export class SnackBarComponent implements OnInit {
  @Input() icon_class: string;
  @Input() icon: string;
  @Input() message: string;
  @Input() actionTitle: string;

  constructor(private snackBarRef: MatSnackBarRef<SnackBarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarConfig) {
  }

  ngOnInit() {
  }

  actionClicked() {
    this.snackBarRef.dismissWithAction();
  }
}

export class SnackBarConfig {
  icon_class: string;
  icon: string;
  message: string;
  actionTitle: string;
}
